import GlyphIcon from "./GlyphIcon.mjs";

/** @type {GlyphIcon} */
const SunsetIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				{...this.props}
				d="M30.5,22.2v1.5H1v-1.5h1.5c.2-.7.7-1.2,1.5-1.2h2.1c0,.4,0,.8-.1,1.2h2c.2-4,3.5-7.2,7.5-7.2,4,0,7.3,3.2,7.5,7.2h2c0-.4,0-.8-.1-1.2h2.1c.7,0,1.3.5,1.5,1.2h2ZM23.2,17l1.5-1.5c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0l-1.5,1.5c.8.6,1.5,1.3,2.1,2.1ZM17,13.2v-2.1c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5,1.5v2.1c1-.2,2-.2,3,0ZM7.8,17c.6-.8,1.3-1.5,2.1-2.1l-1.5-1.5c-.6-.6-1.5-.6-2.1,0s-.6,1.5,0,2.1l1.5,1.5Z"
			/>
		);
	}
}

export default SunsetIcon;